import { setRoleRanking } from '@infuse/api/iam/role';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UserLevel } from '@infuse/iam/user/type';
import { useGenericSetRanking } from './generic/useGenericSetRanking';
import { setOrganisationRoleRanking } from '@infuse/api/iam/organisation';
import { setTenantRoleRanking } from '@infuse/api/iam/tenant';

export const useSetRanking = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.ORGANISATION) {
    return useGenericSetRanking({
      apiFn: setOrganisationRoleRanking,
      forcedParentId: user?.organisationId
    });
  } else if (level === UserLevel.TENANT) {
    return useGenericSetRanking({
      apiFn: setTenantRoleRanking,
      forcedParentId: user?.tenantId
    });
  }

  return useGenericSetRanking({
    apiFn: setRoleRanking
  });
};
